import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseActivityEntity } from './activity-history/base-activity.entity';
import { IssueEntity } from './issue.entity';

@Index('idx_ia_issue_created', ['fkIssueId', 'createdDate'], {})
@Index('idx_ia_type', ['activityType'], {})
@Index('idx_ia_user', ['fkUserId'], {})
@Entity('issue_activity')
export class IssueActivityEntity extends BaseActivityEntity {
	@Column('int', { name: '_fk_issue__id', unsigned: true })
	public fkIssueId!: number;

	@ManyToOne(() => IssueEntity, (issue) => issue.activities, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_issue__id', referencedColumnName: 'id' }])
	public fkIssue!: IssueEntity;
}
